// libraries.
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

// slices.
import { apiDocumentsPortal } from '@store/apiSlices/apiSlices';

// interfaces.
import { ModelError } from '@store/apiSlices/interfaces/interfaces';

export interface SuggestionsAutoCompleteDocsParams {
  country?: string;
  nid?: string;
  businessType?: string;
}

export interface SuggestionsAutoCompleteSuggestionItem {
  default: boolean;
  suggestionId?: number;
  suggestedValue: string;
  initialConfidence: number;
  source: string;
  model: string;
  id?: string;
  sourceName?: string;
  sourceType?: string;
}

export interface SuggestionsAutoCompleteFieldItem {
  field: string;
  fieldConfidenceLevel?: 'HIGH' | 'MEDIUM' | 'LOW';
  fieldId?: number;
  suggestions: SuggestionsAutoCompleteSuggestionItem[];
  defaultValue: string;
  defaultModel: string;
  defaultSource?: string;
  defaultSuggestionId?: number;
}

export interface SuggestionsAutoCompleteTransformedResponse {
  results: SuggestionsAutoCompleteFieldItem[];
}

export const suggestionsAutoCompleteDocs = apiDocumentsPortal.injectEndpoints({
  endpoints: builder => ({
    getSuggestionsAutoCompleteDocs: builder.query<
      SuggestionsAutoCompleteTransformedResponse['results'],
      SuggestionsAutoCompleteDocsParams
    >({
      query: ({
        country,
        nid,
        businessType,
      }: SuggestionsAutoCompleteDocsParams) => {
        return `/suggestions?country=${country}&nid=${nid}&business_type=${businessType}`;
      },
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: 'getSuggestionsAutoCompleteDocs',
        };
        return modelError;
      },
      transformResponse: (
        response: unknown,
        _meta,
        args: SuggestionsAutoCompleteDocsParams
      ) => {
        const data = response as {
          results?: SuggestionsAutoCompleteFieldItem[];
          success?: boolean;
        };
        const results = Array.isArray(data?.results) ? data?.results || [] : [];
        return results;
      },
    }),
  }),
});

export const { useGetSuggestionsAutoCompleteDocsQuery } =
  suggestionsAutoCompleteDocs;
